/* global ga, _sf_async_config, pSUPERFLY, _cc10461, Sailthru, COMSCORE */
import URL from "url-parse";
import { GA_KEY, GA_TRACKED_LINK_TYPE } from "../config/constants";

function initialize() {
  initGA();
  initComscore();
}

function initGA() {
  if (typeof ga !== "undefined") {
    ga("create", GA_KEY, "auto");
    ga("require", "displayfeatures");

    // This won't get hit running webpack-dev-server
    if (document.title.indexOf(" - Axios") > 0) {
      var slicedTitle = document.title.slice(0, document.title.indexOf(" - Axios"));
      ga("send", "pageview", { title: slicedTitle });
    } else {
      ga("send", "pageview");
    }
  }
}

function initComscore() {
  var _comscore = _comscore || [];

  _comscore.push({ c1: "2", c2: "24196029" });

  var s = document.createElement("script");
  var el = document.getElementsByTagName("script")[0];
  s.async = true;
  s.src = (document.location.protocol === "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
  el.parentNode.insertBefore(s, el);
}

function setUser(id) {
  typeof _cc10461 !== "undefined" && id && ga("set", "dimension1", id);
}

function setStream(stream) {
  typeof _cc10461 !== "undefined" && stream && ga("set", "dimension8", stream);
}

function setSections(sections) {
  _sf_async_config.sections = sections.map(function (s) {
    return s.slug;
  }).join(",");
}

function setAuthors(authors) {
  _sf_async_config.authors = authors.map(function (author) {
    return author.username;
  }).join(",");
}

function pageView() {
  typeof ga !== "undefined" && ga("send", "pageview");
}

/*
  This event should be triggered if a post is still in view 3 seconds
  after it was initially registered in the viewport
 */
function userScrollsStoryIntoView(data) {
  var story = data.story,
      stream = data.stream;


  var unpinned = story.is_featured && !story.new_featured;
  var url = new URL(story.permalink);
  typeof ga !== "undefined" && ga("send", {
    hitType: "pageview",
    title: story.headline,
    page: url.pathname,
    dimension4: story.is_featured && !unpinned ? "Yes" : "",
    dimension5: unpinned ? "Yes" : "",
    dimension8: stream,
    dimension9: story.authors.map(function (author) {
      return author.display_name;
    }).join("|"),
    dimension11: story.id
  });

  // Chartbeat
  setSections(story.sections.concat(story.primary_section || []));
  setAuthors(story.authors);
  typeof pSUPERFLY !== "undefined" && pSUPERFLY.virtualPage(story.permalink, story.headline);

  // Lotame
  var sectionTags = story.sections.concat(story.primary_section || []).map(function (s) {
    return s.slug;
  }).concat(story.tags.concat(story.primary_tag || []).map(function (t) {
    return t.name;
  }));
  var postAttributes = sectionTags.join().replace(/ /g, "_");
  typeof _cc10461 !== "undefined" && _cc10461.bcpw("int", postAttributes, "act", postAttributes);

  // Sailthru
  typeof Sailthru !== "undefined" && Sailthru.track("pageview", {
    url: story.permalink
  });

  // Comscore
  typeof COMSCORE !== "undefined" && COMSCORE.beacon({ c1: "2", c2: " 24196029" });
}

function userClicksOnTrackedLink(streamSlug, actionName, buttonLabel) {
  var stream = streamSlug || "";
  typeof ga !== "undefined" && ga("send", {
    hitType: "event",
    eventCategory: "clicks_" + stream,
    eventAction: "clicks_" + stream + "_" + actionName,
    eventLabel: "Clicks on " + buttonLabel + " in " + stream
  });
}

var userClicksInternalLink = function userClicksInternalLink(stream, label) {
  return userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.LINK, label);
};

var userClicksSaveTag = function userClicksSaveTag(stream) {
  return userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SAVE, "Save button");
};

var userClicksReadAnother = function userClicksReadAnother(stream) {
  return userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.READ_ANOTHER, "Read another button");
};

var userClicksKeepReading = function userClicksKeepReading(stream) {
  return userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.READ_MORE, "Keep reading button");
};

var userClicksCopyLink = function userClicksCopyLink(stream) {
  return userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_CL, "Copy link button");
};

var userClicksFacebook = function userClicksFacebook(stream) {
  return userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_FB, "Facebook share button");
};

var userClicksTwitter = function userClicksTwitter(stream) {
  return userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_TW, "Twitter share button");
};

var userClicksLinkedIn = function userClicksLinkedIn(stream) {
  return userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_LI, "LinkedIn share button");
};

var isStoryInView = function isStoryInView(card) {
  // In view story is one where top is above top of page and bottom is still in view
  var bounds = card.getBoundingClientRect();
  return bounds.top < 60 && bounds.bottom > 60;
};

export default {
  initialize: initialize,
  initGA: initGA,
  initComscore: initComscore,
  setUser: setUser,
  setStream: setStream,
  setSections: setSections,
  setAuthors: setAuthors,
  pageView: pageView,
  userScrollsStoryIntoView: userScrollsStoryIntoView,
  userClicksOnTrackedLink: userClicksOnTrackedLink,
  userClicksInternalLink: userClicksInternalLink,
  userClicksSaveTag: userClicksSaveTag,
  userClicksReadAnother: userClicksReadAnother,
  userClicksKeepReading: userClicksKeepReading,
  userClicksCopyLink: userClicksCopyLink,
  userClicksFacebook: userClicksFacebook,
  userClicksTwitter: userClicksTwitter,
  userClicksLinkedIn: userClicksLinkedIn,
  isStoryInView: isStoryInView
};


// WEBPACK FOOTER //
// ./src/utils/analytics.js